import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms'
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, filter, Subject } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-standing-order-list',
  templateUrl: './standing-order-list.component.html',
  styleUrls: ['./standing-order-list.component.css']
})
export class StandingOrderListComponent implements OnInit {
  trip:any;
  spacetypes:any
  // selectedStatus:any = ''
  standingorderMembers: any = [];
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  prespacetypes:any;
  filteredStandingorder:any;
  status:boolean = true
  numberOfRecords = NUMBER_OF_RECORDS
  userPermission=UserPermission
  constructor(
    private tripService: TripService,
    private memberService:MemberService,
    private spaceTypeService: SpaceTypeService,
    private router: Router,
    public permissionService: PermissionService
  ){}
  search: any = '';
  private searchSubject = new Subject<string>();
  


  ngOnInit() {
    this.getSpaceType()
    this.initializeSearch();
    this.getStandingorder(this.currentPage)
  }

  getStandingorder(page: number){
    let queryParams:any = {
      limit: 50,
      page,
      isActive:this.status,
      sortBy: 'pickup.time:asc',
    }

    if (this.search) {
      const trimmedSearch = this.search.trim();
      queryParams.search = trimmedSearch;
    }
    this.tripService.getAllStandingorder(queryParams).pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if (data && data.results){
        this.filteredStandingorder = data.results
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;

      }
    })
  }

  opendetailModal(trip: any) {
    this.trip = trip;
  }


  onPageChange(page: number) {
    this.currentPage = page;
    this.getStandingorder(page);
  }

  getSpaceType() {
    let queryParams = {
      limit: 9999,
      isActive: true,
    }
    this.spaceTypeService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.spacetypes = data.results;
        this.prespacetypes = this.spacetypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  onSelectStatus(){
  this.getStandingorder(this.currentPage = 1);
  }

  newTrip(){
    this.router.navigate(['/trips/new'], {
      state: { isFromStandingOrder: true }
    });
  }


   initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500), // wait for typing to stop
        filter((search:any) => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
      ).subscribe(() => {
        this.currentPage = 1;
        this.getStandingorder(this.currentPage);
      });
    }
  
    onSearchInput() {
      this.searchSubject.next(this.search);
    }
}
